import {tripPlannerApi} from '../api';

export const getPendingQuotes = async () => {
  const response = await tripPlannerApi.get('/quotes/admin/reviews');
  return response;
}

// TODO: If backend endpoint differs, update this template only.
const REVIEW_UPDATE_ENDPOINT_TEMPLATE = (quoteId) => `/quotes/admin/reviews/${quoteId}/approve`;

export const updateQuoteReview = async (quoteId, payload) => {
  const response = await tripPlannerApi.post(REVIEW_UPDATE_ENDPOINT_TEMPLATE(quoteId), payload);
  return response;
}